import type { FaireProductEntity } from "../../entity_types/product";

export const p_wd5xmnwyr7: FaireProductEntity = {
  token: "p_wd5xmnwyr7",
  type: "product",
  name: "Zen Buddha Sand Garden",
  brandToken: "b_23nx3nnsvm",
  brandName: "Pacific Trading",
  imageUrl:
    "https://cdn.faire.com/fastly/f207843dd5eacf61915bb93897dc11aa0ceb72f496280bb3f2fd64649ae4a58a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6536a6289c223fbaa0c3f9ee47ee2a2cbcc63457cf566d35cccb431af2b716bd.jpeg",
    "https://cdn.faire.com/fastly/3f09387ae0e1f37a0f4d9eb5db243a87acbe92256b2169142b553665d4ec0913.jpeg",
    "https://cdn.faire.com/fastly/99148a9facbf2a9f53fba12a231c23ae31a73007b19569542b56eda771f24f8c.jpeg",
    "https://cdn.faire.com/fastly/9b68cd8e193b76c3d90ea85db045940bfdbd7421f9febecfcf12f5766ebfabb9.jpeg",
    "https://cdn.faire.com/fastly/d0a93520f923c261937bb5ad0be2ed3e88d2c30279ba8d868f3e89172bb45501.jpeg",
  ],
  priceDollars: 9.01,
  description:
    'Zen Buddha Sand Garden\nProduct Size:  9.4" X 8.6" X 5.1\nMaterial: Cold Cast Resin\nCase Pack: 18',
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:40.461Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
